import { ConfigStore } from "../../../Common";
export function CanQueryData() {
    return window.navigator.onLine
        && typeof ConfigStore.config.connections.jwt === "string"
        && ConfigStore.config.connections.jwt.length > 0;
}
//# sourceMappingURL=CanQueryData.js.map